import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'components.payments.EditCounterpartyPaymentDetailsPopupContent.IncorrectNamePopupContent',
    {
        title: 'Incorrect name',
        description:
            'The details you entered are very similar to someone already on record. Please review the suggestion and select an option to continue. If you choose to continue using the details originally provided, be aware that paying this person or business may lead to your money being sent to the wrong account, and we may not be able to recover the money for you. Are you sure you want to continue?',
        providedName: 'Provided details',
        suggestedName: 'Suggested details',
        name: 'Name',
        back: 'Back',
        confirm: 'Confirm',
    }
);
